import { render, staticRenderFns } from "./loan_card.vue?vue&type=template&id=06a12282&"
import script from "./loan_card.vue?vue&type=script&lang=js&"
export * from "./loan_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports